<script setup lang="ts">
import { computed } from 'vue';
import { VList } from 'vuetify/components';

type PropsType = {
    density?: VList['$props']['density'];
    classList?: string;
};

const props = withDefaults(defineProps<PropsType>(), { density: 'default' });
const opened = defineModel<string[]>('opened', { required: false, default: () => [] });

const classes = computed(() => {
    return ['b-list', props.classList];
});

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VList
        v-model:opened="opened"
        :density="density"
        v-bind="$attrs"
        :class="classes"
    >
        <slot />
    </VList>
</template>

<style lang="scss" scoped>
.v-list.v-list--density-compact {
    padding-block: 0;
}
</style>
